import { SchemaValidationError, ERROR_SCOPES } from '@builder/utils';
import { StateValueChecker } from './StateValueChecker';
export class StateValueAssert {
    static assertIsStateRequest(stateDSL) {
        if (!StateValueChecker.isRequest(stateDSL)) {
            throw new SchemaValidationError(ERROR_SCOPES.schemas, `State ${stateDSL.id} is not request`);
        }
    }
}
